import { render, staticRenderFns } from "./TwitterEvents.vue?vue&type=template&id=0170f014"
import script from "./TwitterEvents.vue?vue&type=script&lang=js"
export * from "./TwitterEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports